import { slideToggle } from "@roghz/slidetoggle";
import { fadeInAnimations } from "./fade";
import { isInViewport } from "@roghz/isinviewport";
document.addEventListener("DOMContentLoaded", function () {
  fadeInAnimations();
  document.addEventListener("click", e => {
    if (!e.target.closest("#hamburger")) {
      return;
    }

    e.preventDefault();
    const mobileNav = document.querySelector(".site-header__nav");
    const headerLogo = document.querySelector(".site-header__logo");
    const body = document.querySelector("body");
    const hamburger = document.querySelector("#hamburger");
    mobileNav.classList.toggle("open");
    hamburger.classList.toggle("open");
    headerLogo.classList.toggle("open");
    body.classList.toggle("noscroll");
  });
  const mobileDropdown = document.querySelectorAll('.site-header__mobile .menu-item-has-children > a');
  mobileDropdown.forEach(el => {
    el.addEventListener("click", e => {
      if (window.innerWidth < 1024) {
        e.preventDefault();
        e.target.classList.toggle("open");
        console.log(e);
        console.log(e.target);
        slideToggle(e.target.nextElementSibling, 400);
      }
    });
  });
  const counters = document.querySelectorAll('h1 code, h2 code, h3 code, h4 code, h5 code, h6 code, p code');
  const fullPage = document.querySelector('#fullpage');

  if (!fullPage) {
    function count() {
      counters.forEach(item => {
        if (isInViewport(item)) {
          if (!item.classList.contains("animated")) {
            const $this = jQuery(item);
            jQuery({
              Counter: 0
            }).animate({
              Counter: $this.text()
            }, {
              delay: 10000,
              duration: 3500,
              easing: 'swing',
              step: function step() {
                $this.text(Math.ceil(this.Counter));
                return;
              }
            });
            item.classList.add("animated");
          }
        }
      });
    }

    count();

    window.onscroll = function () {
      count();
    };
  } // const appHeight = () => {
  //     const doc = document.documentElement;
  //     doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  // };
  // window.addEventListener("resize", appHeight);
  // appHeight();

});